
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro",
      function () {
        return require("private-next-pages/pro.tsx");
      }
    ]);
  